import React from "react";
import { Row, Col, Card } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import "./index.css";

export default function AddPlantCard({
  cardText,
  cardIcon,
  cardStyle,
  onChangePlantModal,
  ...props
}) {
  return (
    <Row justify="center">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={22}
        className="custom pointer-cursor"
        onClick={onChangePlantModal}
      >
        <Card className="ant-card-body" style={cardStyle}>
          <Col className="addNew-Plant">
            {cardIcon}

            <br></br>
            <p>{cardText}</p>
            {/* {props.children} */}
          </Col>
        </Card>
      </Col>
    </Row>
  );
}
